import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import ContactForm from '../Components/Contact'


const Pricing = () => {
    return (
        <>
            <Navbar/>
            <ContactForm/>
            <Footer/>

            
        </>
    )
}

export default Pricing
